import type { ReactNode } from 'react';

import { Box } from '@mui/material';
import { Link } from 'react-router';

import { GrayLinkButton } from '@/shared/ui/primitives/Button/GrayLinkButton';
import Typography from '@/shared/ui/typography/Text';

export interface ActionEmptyStateAction {
  label: string;
  to: string;
  icon: ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  replace?: boolean;
  onClick?: () => void;
}

export interface ActionEmptyStateProps {
  title: string;
  description: ReactNode;
  actions?: ActionEmptyStateAction[];
}

export const ActionEmptyState = ({ title, description, actions }: ActionEmptyStateProps) => {
  return (
    <Box
      sx={{
        py: '36px',
        px: 2,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        flex: 1
      }}
    >
      <Typography
        size={24}
        sx={{ fontWeight: 700 }}
      >
        {title}
      </Typography>
      <Typography>{description}</Typography>
      {actions?.map(action => (
        <GrayLinkButton
          key={action.to}
          component={Link}
          replace={action.replace}
          startIcon={action.icon}
          to={action.to}
          variant={action.variant}
          onClick={action.onClick}
        >
          {action.label}
        </GrayLinkButton>
      ))}
    </Box>
  );
};
